import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { MatDialogRef } from '@angular/material/dialog';
import { CountryId } from 'src/common-panel/constants/country-configs.constants';
import { GoogleAddressCompTypesEnum } from 'src/shop-manager/common/enums/google-address-comp-types-enum';
import { ClinicOfficeManageService } from 'src/shop-manager/services/clinic-office-manage.service';

@Component({
    selector: 'app-map-selection-dialog',
    templateUrl: './map-selection-dialog.component.html',
    styleUrls: ['./map-selection-dialog.component.css'],
    standalone: false
})
export class MapSelectionDialogComponent implements AfterViewInit
{

  @ViewChild("mapSearchField") searchField?: ElementRef
  @ViewChild(GoogleMap) map?: GoogleMap

  mapConfigurations = {}

  markerOptions: google.maps.MarkerOptions = { draggable: false };
  markerPosition?: google.maps.LatLngLiteral

  longitude: string = ''
  latitude: string = ''

  country:string=""
  city: string = ""
  state: string = ""
  addressLine1: string = ""
  addressLine2: string = ""
  zipCode: string = ""

  constructor(private dialogRef: MatDialogRef<any>, private clinicOfficeManageService: ClinicOfficeManageService)
  {

  }

  ngAfterViewInit(): void
  {
    if (this.searchField)
    {
      const searchBox = new google.maps.places.SearchBox(this.searchField?.nativeElement)
      this.map?.controls[google.maps.ControlPosition.TOP_CENTER].push(this.searchField.nativeElement)

      searchBox.addListener("places_changed", () =>
      {
        this.clearAll()
        const places = searchBox.getPlaces();
        if (places?.length === 0) return;
        if (places)
        {
          const bounds = new google.maps.LatLngBounds();
          console.log(bounds)
          places.forEach(place =>
          {

            if (place.address_components) this.setAddress(place.address_components)
            if (!place.geometry || (place.geometry && !place.geometry.location)) return;
            if (place.geometry.viewport)
            {
              this.setCoordinates(place.geometry.viewport.getCenter().lat(), place.geometry.viewport.getCenter().lng())
              bounds.union(place.geometry.viewport)
            } else
            {
              bounds.extend(place.geometry.location as google.maps.LatLng)
              console.log('l ' + place.geometry.location)
            }
            this.markerPosition = place.geometry.location!.toJSON();
          });
          this.map?.fitBounds(bounds)
        }
      })

      this.map?.mapClick.subscribe(event =>
      {
        this.clearAll()
        if (event.latLng)
        {
          this.setCoordinates(event.latLng.lat(), event.latLng.lng())
          this.markerPosition = event.latLng.toJSON();
          this.getAddress(event.latLng.lat(), event.latLng.lng())

        }

      })

    }
  }

  setAddress(components: google.maps.GeocoderAddressComponent[])
  {
    let l_zipCodeSuffix = ''
    let l_zipCode = ''

    let l_street ='' 
    let l_streetNumber ='' 
    let l_shortState=''
    components.forEach(part =>
    {
      
      if (part.types.includes(GoogleAddressCompTypesEnum.country)) { this.country = part.short_name }
      if (part.types.includes(GoogleAddressCompTypesEnum.postal_code)) { l_zipCode = part.long_name }
      if (part.types.includes(GoogleAddressCompTypesEnum.postal_code_suffix)) { l_zipCodeSuffix = part.long_name }
      if (part.types.includes(GoogleAddressCompTypesEnum.locality)) { this.city = part.long_name }
      if (part.types.includes(GoogleAddressCompTypesEnum.administrative_area_level_1)) { 
        this.state = part.long_name
      l_shortState=part.short_name }
      if (part.types.includes(GoogleAddressCompTypesEnum.route)) { l_street = part.long_name }
      if (part.types.includes(GoogleAddressCompTypesEnum.street_number)) { l_streetNumber = part.long_name }
    })

    this.addressLine1=l_street+' '+l_streetNumber
    this.zipCode = l_zipCodeSuffix ? l_zipCode + ' ' + l_zipCodeSuffix : l_zipCode
    if((this.country).toString() == "US" || (this.country).toString() == "UV"){
          this.addressLine2= this.city+ `, ${l_shortState} ` + this.zipCode 
    }else{
      this.addressLine2= this.zipCode + ` `+this.city;
      this.state=''
    }


    console.log('city - ' + this.city)
    console.log('state - ' + this.state)
    console.log('zipCode - ' + this.zipCode)
    console.log('addressLine1 - ' + this.addressLine1)
    console.log('addressLine2 - ' + this.addressLine2)
  }

  setCoordinates(lat: number, lng: number)
  {
    this.latitude = lat.toString();
    this.longitude = lng.toString();
    console.log('latitude - ' + this.latitude)
    console.log('longitude - ' + this.longitude)
  }

  onSubmit()
  {
    this.clinicOfficeManageService.address={
      longitude: this.longitude,
      latitude: this.latitude,
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      city: this.city,
      state: this.state,
      zipCode: this.zipCode
  
    }
    this.clinicOfficeManageService.coordinatesToUpdate.next(true)
    this.dialogRef.close()
  }

  getAddress(lat: number, lng: number)
  {
    console.log('Finding Address');
    if (navigator.geolocation)
    {
      let geocoder = new google.maps.Geocoder();
      let latlng = new google.maps.LatLng(lat, lng);
      geocoder.geocode({ location: latlng }, (results, status) =>
      {
        if (status === google.maps.GeocoderStatus.OK && results)
        {
          let result = results[0];
          let rsltAdrComponent = result.address_components;
          if (result != null)
          {
            if (rsltAdrComponent) this.setAddress(rsltAdrComponent)
          } else
          {
            console.log('No address available!');
          }
        }
      });
    }
  }

  clearAll()
  {
    this.longitude = ''
    this.latitude = ''

    this.city = ""
    this.state = ""
    this.addressLine1 = ""
    this.addressLine2 = ""
    this.zipCode = ""
  }
}
